// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"183":"5c3af1fd","220":"6004c44a","752":"d0693b28"}[chunkId] + ".chunk.css";
};